module.exports = __webpack_public_path__ + "static/media/08.fa61f961.png";